import CmsBaseClass from "@/helpers/cms/CmsBaseClass.js";
import {tr} from "@vue-components/helpers/I18nPluginHelper.js";

export default class CmsBlockTemplate extends CmsBaseClass {
    get typeDef() {
        return this.constructor.typeDef;
    }

    get displayName() {
        if (this.name) {
            return this.name;
        }
        return tr(`Template|Modèle`);
    }

    static typeDef = {
        name: `Template`,
        glyph: `fa-layer-group`,
        type: `template`,
        category: `template`
    }

    get ignoredFields() {
        return [];
    }

    get autoGenerateId() {
        return false;
    }

    constructor(data) {
        super(data);

        this.dealerid = data?.dealerid ?? this.dealerid ?? null;

        if (!data) {
            this.dealerid = null;
            this.websiteId = null;
            this.name = ``;
            this.description = ``;
            this.block = null;
            this.deleted = false;
            this.deletedAt = null;
            this.createdAt = new Date();
            this.updatedAt = new Date();
        }
    }

    /**
     * Validate template data
     * @returns {boolean}
     */
    isValid() {
        return !!(this.websiteId && this.dealerid && this.name && this.block);
    }

    /**
     * Get template summary for display
     * @returns {Object}
     */
    getSummary() {
        return {
            id: this.id,
            name: this.name,
            description: this.description,
            websiteId: this.websiteId,
            blockType: this.block?.type || null,
            createdAt: this.createdAt,
            updatedAt: this.updatedAt
        };
    }

    /**
     * Update template metadata
     * @param {string} name
     * @param {string} description
     */
    updateMetadata(name, description) {
        this.name = name;
        this.description = description;
        this.updatedAt = new Date();
    }

    /**
     * Update block data
     * @param {Object} blockData
     */
    updateBlock(blockData) {
        this.block = blockData;
        this.updatedAt = new Date();
    }

    /**
     * Soft delete the template
     */
    softDelete() {
        this.deleted = true;
        this.deletedAt = new Date();
    }

    /**
     * Restore a deleted template
     */
    restore() {
        this.deleted = false;
        this.deletedAt = null;
    }
}
